module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABGklEQVRYR+2WTQ6CMBCFO+kFOIKeQAmz1yN4BW/mEbyB7DsJ3kTcQzQYTQi2fQMNYUO3r3nz9XX6Q2bhQQvXNyvAmkA0ARE5dU3KzFdfsyJd0+BBgKqqsrZtH50JEZ2Lorj0DZGuKf7xjk10zpVEdAhBIF0DEQX4rrI0xux8EEhPBugMUBGkIwjVMURFkB6DUAHMmYQaYC6IUQBzQIwG8EDU1tptnuf1b6+HPcHMwTqTAZqmuRHR3hjztNZuhgB9nZmzUCOOBuhW1zP/uyWRPgQZBYDMke5LQQ2AzJGetAXIHOlJFxEyR3rSVYzMkY6KJz/HInIPvZSa4hBARF5Lf0iORJSFvmTOuaiuSUF9DDVmU+asAGsCiyfwBkT8IjChCIx8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double_arrow.png
// module id = 1wkb
// module chunks = 1